(function() {
    'use strict';

    angular
        .module('platformApp')
        .controller('PsdFontMappingController', PsdFontMappingController);

    PsdFontMappingController.$inject = ['Auth', 'Principal', '$scope', '$q', 'MessageService', '$state', '$uibModalInstance','UidService','$timeout', 'entity'];

    function PsdFontMappingController (Auth, Principal, $scope, $q, MessageService, $state, $uibModalInstance,UidService,$timeout, entity) {
        var vm = this;
        vm.fontList = entity.fontList || [];
        vm.psdFile = entity.psdFile || {};
        vm.psdData = JSON.parse(vm.psdFile.data);
        vm.fontMapping = { items: [] }
        if (vm.psdFile.fontMapping) {
        	vm.fontMapping = angular.copy(entity.psdFile.fontMapping) || { items: []}
    	}
        if (!vm.fontMapping) {
        	vm.fontMapping = {};
        }
        if (!vm.fontMapping.items) {
        	vm.fontMapping.items = [];
        }
        if (!vm.fontMapping.items.length) {
        	loadFromPsd();
        }

        vm.addFontItem = function() {
        	vm.fontMapping.items.push({
        		name: "",
        		fontId: null,
        		fontName: null,
        		fontUuid: null
        	});
        }

        vm.deleteFontItem = function($index) {
        	if ($index < 0 || $index >= vm.fontMapping.items.length) {
        		return;
        	}
        	vm.fontMapping.items.splice($index, 1);
        }

        vm.loadFromPsd = loadFromPsd;
        function loadFromPsd() {
        	if (vm.psdData && vm.psdData.layers) {
        		for (var i = 0; i < vm.psdData.layers.length; i++) {
        			var layer = vm.psdData.layers[i];
        			if (layer.type != "Text") {
        				continue;
        			}
        			var font = layer.style.font;
        			if (!font) {
        				continue;
        			}
        			var found = false;
        			for (var j = 0; j < vm.fontMapping.items.length; j++) {
        				var item = vm.fontMapping.items[j];
        				var itemName = item.name ? item.name.trim() : "";
        				if (font == itemName) {
        					found = true;
        					break;
        				}
        			}
        			if (!found) {
        				vm.fontMapping.items.push({
			        		name: font,
			        		fontId: null,
			        		fontName: null,
			        		fontUuid: null
			        	});
        			}
        		}
        	}
        }

        vm.onMappingItemChange = function ($index) {
        	if ($index < 0 || $index >= vm.fontMapping.items.length) {
        		return;
        	}
        	var item = vm.fontMapping.items[$index];
        	if (item.fontId) {
        		for (var i =0; i < vm.fontList.length; i++) {
        			var font = vm.fontList[i];
        			if (item.fontId == font.id) {
        				item.fontName = font.family;
        				item.fontUuid = font.uuid;
        				break;
        			}
        		}
        	}
        	else {
        		item.fontName = null;
        		item.fontUuid = null;
        	}
        }

        vm.save = function() {
        	if (vm.fontMapping.items.length > 0) {
        		for (var i = 0; i < vm.fontMapping.items.length; i++) {
        			var item = vm.fontMapping.items[i];
        			if (!item.name) {
        				MessageService.error("第" + (i + 1) + "个字体名称无效");
        				return
        			}
        			if (!item.fontId) {
        				MessageService.error("第" + (i + 1) + "个映射字体未选择");
        				return
        			}
        		}
        	}
        	$uibModalInstance.close(vm.fontMapping);
        }


        vm.cancel = function () {
            $uibModalInstance.dismiss();
        }

    }
})();